import { Button } from "@wags/ui/button.tsx";
import { ArrowUpIcon } from "@wags/ui/product-icons.tsx";
import { useRef, useState } from "react";

export function FaqAskRow({
    label,
    onSubmit,
}: {
    label: string;
    onSubmit: (question: string) => void;
}) {
    const [draft, setDraft] = useState("");
    const inputRef = useRef<HTMLInputElement>(null);
    const question = draft.trim().replace(/\s+/g, " ");
    const empty = question === "";

    return (
        <form
            onSubmit={(event) => {
                event.preventDefault();
                if (empty) return;
                setDraft("");
                inputRef.current?.blur();
                onSubmit(question);
            }}
            className="flex items-center gap-3"
        >
            <input
                ref={inputRef}
                aria-label={label}
                value={draft}
                maxLength={200}
                autoComplete="off"
                enterKeyHint="send"
                placeholder={label}
                onChange={(event) => setDraft(event.target.value)}
                onKeyDown={(event) => {
                    const confirmsImeCandidate =
                        event.nativeEvent.isComposing || event.keyCode === 229;
                    if (event.key === "Enter" && confirmsImeCandidate) {
                        event.preventDefault();
                    }
                    if (event.key === "Escape") {
                        event.currentTarget.blur();
                    }
                }}
                className="min-w-0 flex-1 bg-transparent text-base text-doberman-black outline-none placeholder:text-doberman-black/45 md:text-body"
            />
            <Button
                type="submit"
                variant="dark"
                size="icon-sm"
                aria-label="Send"
                disabled={empty}
            >
                <ArrowUpIcon className="size-4" />
            </Button>
        </form>
    );
}
